module.exports = __webpack_public_path__ + "static/media/1022127.cd156f90.jpg";